var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCywTiwbHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 229 239",
    style: {
      enableBackground: "new 0 0 229 239"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#2A2A27;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FDDD00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 114.5,
    cy: 124.5,
    r: 114.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 114.5,
    cy: 114.5,
    r: 114.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 114.5,
    cy: 114.5,
    r: 84.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.3,161.1H79.6c-2.6,0-4.7-2.1-4.7-4.7v-36.1c0-2.6-2.1-4.7-4.7-4.7h0c-4.3,0-6.4-5.3-3.2-8.2l44.4-40 c1.8-1.6,4.5-1.6,6.3,0l44.4,40c3.2,2.9,1.2,8.2-3.2,8.2h0c-2.6,0-4.7,2.1-4.7,4.7v36.1c0,2.6-2.1,4.7-4.7,4.7h-18.8 c-2.6,0-4.7-2.1-4.7-4.7v-24.6c0-2.6-2.1-4.7-4.7-4.7h-13.4c-2.6,0-4.7,2.1-4.7,4.7v24.6C103.1,159,100.9,161.1,98.3,161.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCywTiwbHome);
export default __webpack_public_path__ + "static/media/cywTiwbHome.9b3c3acfd5eb25666205194e8a69c880.svg";
export { ForwardRef as ReactComponent };